import React, { useCallback, useMemo, useRef } from "react";

import Actionbar from "src/components/common/actionbar/Authactionbar";
import useUiuxStore from "src/store/useUiuxStore";


import { useMouseContent } from "src/utils/mouse/mouseContent";

import { AgGridReact } from "ag-grid-react";
import { Content_KSK2022_R01 } from "./Content_KSK2022_R01";
import { DetailTable_KSK2022_R01 } from "./table/DetailTable_KSK2022_R01";
import { KSK2022_R01DetailDto, KSK2022_R01HeaderDto, KSK2022_R01InspectDto, KSK2022_R01LotDto } from "./Dto_KSK2022_R01";
import { Info_KSK2022_R01 } from "./info/Info_KSK2022_R01";
import { ResultInfo_KSK2022_R01 } from "./info/ResultInfo_KSK2022_R01";
import { LotTable_KSK2022_R01 } from "./table/LotTable_KSK2022_R01";
import { Modal_KSK2022_R01 } from "./modal/Modal_KSK2022_R01";
import { useKSK2022_R01Store } from "./Store_KSK2022_R01";
import { WorkTimeModal_KSK2022_R01 } from "./modal/WorkTimeModal_KSK2022_R01";
import { ImagePreviewModal } from "src/components/common/form/ImagePreviewModal";


export const Container_KSK2022_R01 = () => {

	const { 
		initData, syncInitialData,
		isDetailMaximized, setIsDetailMaximized,
		isResultLotMaximized, setIsResultLotMaximized,
		editKSK2022_R01, KSK2022_R01WorkStandard,
		workStandardModalVisible, setWorkStandardModalVisible, workStandardSheetNo,
	} = useKSK2022_R01Store();

	const { tabList, setMessage } = useUiuxStore();

	const RESIZER_HEIGHT = {
		code: 'KSK2022_R01',
		type: 'height',
		storageKey: 'KSK2022_R01-info-split-height',
		min: 5,
		max: 80,
		default: 60
	} as const;

	const RESIZER_LOT = {
		code: 'KSK2022_R01_lot',
		type: 'width',
		storageKey: 'KSK2022_R01-info-result-split-width',
		min: 20,
		max: 80,
		default: 33
	} as const;

	const RESIZER_RESULT_LOT = {
		code: 'KSK2022_R01_result_lot',
		type: 'width',
		storageKey: 'KSK2022_R01-result-lot-split-width',
		min: 20,
		max: 80,
		default: 58
	} as const;

	const gridRef = useRef<AgGridReact<KSK2022_R01HeaderDto>>(null);
	const lotGridRef = useRef<AgGridReact<KSK2022_R01LotDto>>(null);
	const detailGridRef = useRef<AgGridReact<KSK2022_R01DetailDto>>(null);
	const inspectGridRef = useRef<AgGridReact<KSK2022_R01InspectDto>>(null);

	const containerRef = useRef<HTMLDivElement>(null);
	const infoAreaRef = useRef<HTMLDivElement>(null);
	const lotInfoRef = useRef<HTMLDivElement>(null);
	const resultLotContainerRef = useRef<HTMLDivElement>(null);
	const resultInfoRef = useRef<HTMLDivElement>(null);
	const bottomContainerRef = useRef<HTMLDivElement>(null);
	const isHeightResizing = useRef(false);
	const isLotResizing = useRef(false);
	const isResultLotResizing = useRef(false);

	const {
		splitValue: heightSplitValue,
		handleMouseDown: handleHeightMouseDown,
	} = useMouseContent({
		resizer: RESIZER_HEIGHT,
		isResizing: isHeightResizing,
		containerRef,
		infoRef: infoAreaRef
	});

	const {
		splitValue: lotSplitValue,
		handleMouseDown: handleLotMouseDown,
	} = useMouseContent({
		resizer: RESIZER_LOT,
		isResizing: isLotResizing,
		containerRef,
		infoRef: lotInfoRef
	});

	const {
		splitValue: resultLotSplitValue,
		handleMouseDown: handleResultLotMouseDown,
	} = useMouseContent({
		resizer: RESIZER_RESULT_LOT,
		isResizing: isResultLotResizing,
		containerRef: resultLotContainerRef,
		infoRef: resultInfoRef
	});

	const {
		// fetchData,
		fetchOne,
		defaultKSK2022_R01HeaderRow,
		defaultKSK2022_R01LotRow,
		defaultKSK2022_R01DetailRow,
		defaultKSK2022_R01InspectRow,
		initContainerData,
		handleWorkResetClick,
		handleDeleteClick,
		handleCreateClick,
		handleSaveClick,
		handleWorkTimeClick,
		handleFetchBomProductList,
		getProductWorkFieldHandlers,
		handleFetchLotList,
		handleFetchProductResult,
		handleLotCountChange,
		handleLotCountResetClick,
		isLotCountResetting,
		handleLotCreateClick,
		handleInspectConfirmClick,
		handleWorkStandardClick,
	} = Content_KSK2022_R01({
		gridRef,
		lotGridRef,
		detailGridRef,
		inspectGridRef,
		tabList, setMessage,
		containerRef,
		isResizing: isHeightResizing,
	});

	const handleToggleResultLotMaximize = useCallback(() => {
		const next = !isResultLotMaximized;
		setIsResultLotMaximized(next);
		if (next) setIsDetailMaximized(false);
	}, [isResultLotMaximized, setIsResultLotMaximized, setIsDetailMaximized]);

	const handleToggleDetailMaximize = useCallback(() => {
		const next = !isDetailMaximized;
		setIsDetailMaximized(next);
		if (next) setIsResultLotMaximized(false);
	}, [isDetailMaximized, setIsDetailMaximized, setIsResultLotMaximized]);

	useMemo(() => { syncInitialData(); }, []);

	const headerDefaultRow = useMemo(() => defaultKSK2022_R01HeaderRow(), [defaultKSK2022_R01HeaderRow]);
	const lotDefaultRow = useMemo(() => defaultKSK2022_R01LotRow(), [defaultKSK2022_R01LotRow]);
	const detailDefaultRow = useMemo(() => defaultKSK2022_R01DetailRow(), [defaultKSK2022_R01DetailRow]);
	const inspectDefaultRow = useMemo(() => defaultKSK2022_R01InspectRow(), [defaultKSK2022_R01InspectRow]);

	return <div className={`content-container`}>
		<Actionbar
			onFetchClick={handleFetchLotList}
			onCreateClick={handleCreateClick}
			onDeleteClick={handleDeleteClick}
			onSaveClick={handleSaveClick}
			onInitClick={initContainerData}
		/>
		<WorkTimeModal_KSK2022_R01 handleWorkTimeClick={handleWorkTimeClick} />
		<ImagePreviewModal
			isOpen={workStandardModalVisible}
			title={`작업표준${workStandardSheetNo ?? ''} - ${editKSK2022_R01?.workplaceNm || editKSK2022_R01?.workplaceCd || ''} / ${editKSK2022_R01?.itemCd || ''}`}
			image={workStandardSheetNo === 1 ? KSK2022_R01WorkStandard?.standardSheet || '' : KSK2022_R01WorkStandard?.standardSheet2 || ''}
			onClose={() => setWorkStandardModalVisible(false)}
		/>
		{/* <SearchSection_KSK2022_R01 onEnterKeyDown={() => { fetchOne(); }} /> */}

		{/* 불량사유 전체 행 표시와 수량 입력은 불량 등록 모달 내부에서 처리한다. */}
		<Modal_KSK2022_R01 
			inspectGridRef={inspectGridRef}
			defaultKSK2022_R01InspectRow={inspectDefaultRow}
			handleInspectConfirmClick={handleInspectConfirmClick}
		/>

		<div className="flex h-full min-h-0 w-full flex-1 flex-col gap-[10px] overflow-hidden bg-[#eaf0f8] p-[14px]" ref={containerRef}>
			{!isDetailMaximized && (
					<>
					{/* Info | 좌우리사이저 | ResultInfo+LotTable (최대화 시 ResultInfo+LotTable만 전체) */}
					<div
						className="w-full max-w-full flex flex-1 gap-[8px] min-h-0"
						style={{ height: `${heightSplitValue}%` }}
					>
						{!isResultLotMaximized && (
							<>
								{/* 좌측 Info */}
								<div
									className="h-full max-h-full flex min-w-0"
									ref={lotInfoRef}
									style={{ width: `${lotSplitValue}%` }}
								>
									<Info_KSK2022_R01 editable={false}
										defaultKSK2022_R01HeaderRow={headerDefaultRow}
										handleFetchBomProductList={handleFetchBomProductList}
										handleFetchLotList={handleFetchLotList}
										getProductWorkFieldHandlers={getProductWorkFieldHandlers}
									/>
								</div>

								{/* 좌우 리사이저 */}
								<div
									className="w-[4px] rounded-full bg-[#cbd7e8] cursor-col-resize hover:bg-[#9fb3cf] shrink-0"
									onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleLotMouseDown('LR', e.nativeEvent)}
								/>
							</>
						)}

						{/* 생산실적 등록 + 발생 LOT 목록 */}
						<div
							className="h-full max-h-full flex flex-col min-h-0 min-w-0"
							style={{ width: isResultLotMaximized ? '100%' : `${100 - lotSplitValue}%` }}
						>
							<div className="w-full flex-1 min-h-0 flex gap-[8px]" ref={resultLotContainerRef}>
								<div
									className="h-full max-h-full flex min-w-0"
									ref={resultInfoRef}
									style={{ width: `${resultLotSplitValue}%` }}
								>
									<ResultInfo_KSK2022_R01
										defaultKSK2022_R01HeaderRow={headerDefaultRow}
										defaultKSK2022_R01LotRow={lotDefaultRow}
										getProductWorkFieldHandlers={getProductWorkFieldHandlers}
										handleFetchLotList={handleFetchLotList}
										handleFetchProductResult={handleFetchProductResult}
										handleLotCountChange={handleLotCountChange}
										handleLotCountResetClick={handleLotCountResetClick}
										isLotCountResetting={isLotCountResetting}
										handleLotCreateClick={handleLotCreateClick}
										handleWorkTimeClick={handleWorkTimeClick}
										handleWorkResetClick={handleWorkResetClick}
										handleWorkStandardClick={handleWorkStandardClick}
									/>
								</div>
								<div
									className="w-[4px] rounded-full bg-[#cbd7e8] cursor-col-resize hover:bg-[#9fb3cf] shrink-0"
									onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleResultLotMouseDown('LR', e.nativeEvent)}
								/>
								<div
									className="h-full max-h-full flex flex-col min-h-0 min-w-0"
									style={{ width: `${100 - resultLotSplitValue}%` }}
								>
									<LotTable_KSK2022_R01
										lotGridRef={lotGridRef}
										defaultKSK2022_R01LotRow={lotDefaultRow}
										isMaximized={isResultLotMaximized}
										onToggleMaximize={handleToggleResultLotMaximize}
									/>
								</div>
							</div>
						</div>
					</div>

					{/* 하단 리사이저 */}
					<div
						className="h-[4px] rounded-full bg-[#cbd7e8] cursor-row-resize hover:bg-[#9fb3cf]"
						onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleHeightMouseDown('UD', e.nativeEvent)}
					/>
				</>
			)}
			{/* 하단: DetailTable */}
			<div
				ref={infoAreaRef}
				style={{ height: isDetailMaximized ? '100%' : `${100 - heightSplitValue}%` }}
			>
				<div className="flex h-full" ref={bottomContainerRef}>
					<DetailTable_KSK2022_R01
						gridRef={detailGridRef}
						defaultKSK2022_R01DetailRow={detailDefaultRow}
						isMaximized={isDetailMaximized}
						onToggleMaximize={handleToggleDetailMaximize}
					/>
				</div>
			</div>

		</div>
	</div>
}
